import { getSDGs } from "../services/SdgServices";
import { useEffect, useState } from "react";

export const useSDGs = () => {
  const [sdgs, setSdgs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getSDGs()
      .then((response) => {
        setSdgs(response.sdgs);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);
  return { sdgs, loading };
};
